module.exports = __webpack_public_path__ + "img/ingg.18c4eecf.png";